/* eslint-disable camelcase */
import { useState } from 'react';
import getThemeFromRegistry from './getThemeFromRegistry';
import { ThemeProvider } from '@mui/material/styles';
import createEffectiveTheme from './createEffectiveTheme';
import { useInterstateRegistryContext } from '../InterstateRegistryProvider/InterstateRegistryContext';
import './interstateThemeProviderCSS';
import { InterstateThemeContext } from './InterstateThemeContext';
/**
 * Provides the Interstate theme.  If the provided theme name is in the registry it will be loaded.
 * @param {string}          themeName           The theme name to use.  If the name is not in the registry then
 * @param {node[]}          children            The child nodes to render
 * @param {string}          scopeName           The scope of the provider
 * @param {string}          applicationName     The name of the application
 * @returns {JSX.Element}
 * @constructor
 */

/** The InterstateBaseThemeProvider provides the theme styling to the application.  It will inject the Interstate Theme data into the
 MUI theme
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const InterstateBaseThemeProvider = _ref => {
  let {
    themeName,
    children,
    applicationName,
    scopeName
  } = _ref;
  const registry = useInterstateRegistryContext();
  const [currentThemeName, setCurrentThemeName] = useState(themeName);
  if (!registry) {
    throw new Error('The registry value is not defined.  Check to see if there is a parent instance of InterstateRegistryProvider');
  }
  const themeFromRegistry = getThemeFromRegistry(currentThemeName, registry);
  if (!themeFromRegistry) {
    throw new Error(`Theme ${currentThemeName} is not a valid theme in theme registry`);
  }
  const selectedTheme = getThemeFromRegistry(currentThemeName, registry);
  const effectiveTheme = createEffectiveTheme(selectedTheme.themeLoader, 'light');
  const themeContext = {
    applicationName,
    scopeName,
    themeName: currentThemeName,
    dispatch: setCurrentThemeName
  };
  return /*#__PURE__*/_jsx(InterstateThemeContext.Provider, {
    value: themeContext,
    children: /*#__PURE__*/_jsx(ThemeProvider, {
      theme: effectiveTheme,
      children: children
    })
  });
};